/**
 * A read-only pipeline funnel: one horizontal bar per stage, width proportional
 * to the largest stage so the biggest backlog is obvious at a glance. Zero-count
 * stages are dimmed rather than hidden, so the whole pipeline stays legible.
 *
 * App-agnostic: the caller supplies the ordered stages with their domain label
 * and colour (the state palette lives in each app). Renders against the shared
 * `.funnel` styles in @kolectra/shared/styles.css.
 */
export interface FunnelStage {
  key: string;
  label: string;
  count: number;
  color: string;
}

export function PipelineFunnel({ stages }: { stages: FunnelStage[] }) {
  const max = Math.max(1, ...stages.map((s) => s.count));
  return (
    <div className="funnel">
      {stages.map((s) => (
        <div key={s.key} className={'funnelrow' + (s.count === 0 ? ' dim' : '')}>
          <span className="fl">
            <span className="dot" style={{ background: s.color }} />
            {s.label}
          </span>
          <span className="ftrack">
            <i style={{ width: `${(s.count / max) * 100}%`, background: s.color }} />
          </span>
          <span className="fn">{s.count.toLocaleString('en-US')}</span>
        </div>
      ))}
    </div>
  );
}
